import ContractsMileageListResponse, {
  ContractsMileageListResponseItem,
} from "../../../../api/raily/contracts/mileage/list/contracts-mileage-list.response";
import ContractsMileageList, {
  ContractsMileageListItem,
} from "./contracts-mileage-list";

const createDataItem = (
  item: ContractsMileageListResponseItem,
): ContractsMileageListItem => {
  return {
    uuid: item.id,
    companyUuid: item.companyId,
    validSince: item.validSince,
    validTo: item.validTo,
    modificationDate: item.modifiedAt,
    modifiedBy: item.modifiedBy,
    createdAt: item.createdAt,
    createdBy: item.createdBy,
    dietFullAfterHours: item.dietFullAfterHours,
    dietFullRate: item.dietFullRate,
    dietHalfAfterHours: item.dietHalfAfterHours,
    dietHalfRate: item.dietHalfRate,
    disabled: item.disabled,
    distanceRateCarGt900cm3: item.distanceRateCarGt900cm3,
    distanceRateCarLe900cm3: item.distanceRateCarLe900cm3,
    distanceRateCompanyVehicle: item.distanceRateCompanyVehicle,
    distanceRateMoped: item.distanceRateMoped,
    distanceRateMotorcycle: item.distanceRateMotorcycle,
    companyName: item.companyName,
  };
};

const createData = (
  responseData: ContractsMileageListResponseItem[],
): ContractsMileageListItem[] => {
  const items: ContractsMileageListItem[] = responseData.map(createDataItem);

  return items;
};

const create = (
  response: ContractsMileageListResponse,
): ContractsMileageList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const contractsMileageListFactory = {
  create,
};

export default contractsMileageListFactory;
